var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"range-inline"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('range-list',{attrs:{"items":_vm.items,"view":_vm.view,"rangetype":_vm.rangetype},on:{"select":function($event){return _vm.$emit('select', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }